const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

const resolveCanonical = (tz: string) =>
  Intl.DateTimeFormat(undefined, { timeZone: tz }).resolvedOptions().timeZone;

export const timezoneOptions = (
  timezone?: string | null
): Intl.DateTimeFormatOptions => {
  if (!timezone) return {};

  const options: Intl.DateTimeFormatOptions = { timeZone: timezone };
  if (resolveCanonical(timezone) !== browserTimezone)
    options.timeZoneName = "short";

  return options;
};

export const SHOWING_TIME_FORMAT: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
  hour12: true
};

export const formatShowingDateTime = (
  iso?: string | null,
  timezone?: string | null
): string | null => {
  if (!iso) return null;
  const ms = new Date(iso).getTime();
  if (Number.isNaN(ms)) return null;
  try {
    return new Date(ms).toLocaleString("en-US", {
      ...SHOWING_TIME_FORMAT,
      ...timezoneOptions(timezone)
    });
  } catch {
    return new Date(ms).toLocaleString("en-US", SHOWING_TIME_FORMAT);
  }
};
